import {MaterialDemandByDay, getDemandDataPerMaterial} from '@domain/material-demand'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'
import {useCallback} from 'react'

import {type MomentRange, convertToDate} from '../../../utils'
import {fetchMaterialDemand, salesForecastQueryKeys} from '../backend'

interface MaterialDemandPerMaterialQueryParams {
  timeFrame: MomentRange
  timezoneId: string
  selectedDate?: string
}

/**
 * Hook used for the demand table – aggregates demand data per material for a date range or single date.
 */
export const useMaterialDemandPerMaterialQuery = ({
  timeFrame,
  timezoneId,
  selectedDate
}: MaterialDemandPerMaterialQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  const fromDate = convertToDate(timeFrame[0].clone().tz(timezoneId))
  const toDate = convertToDate(timeFrame[1].clone().tz(timezoneId))

  const selector = useCallback(
    (data: MaterialDemandByDay) => {
      const dataFilteredByDate = selectedDate ? {[selectedDate]: data[selectedDate] ?? []} : data
      return getDemandDataPerMaterial(dataFilteredByDate)
    },
    [selectedDate]
  )

  return useQuery({
    queryKey: [salesForecastQueryKeys.materialDemand, plantCode, {fromDate, toDate}],
    queryFn: ({signal}) => fetchMaterialDemand(plantCode, fromDate, toDate, signal),
    select: selector,
    throwOnError: true
  })
}
